import { http, createConfig } from 'wagmi'
import { injected } from 'wagmi/connectors'
import { getWagmiConnectorV2 } from '@binance/w3w-wagmi-connector-v2'
import { bsc } from 'wagmi/chains'
import { QueryClient } from '@tanstack/react-query'

// 创建币安钱包连接器
const binanceConnector = getWagmiConnectorV2()

// 创建wagmi配置 - 专注于BSC
export const wagmiConfig = createConfig({
  chains: [bsc], // BSC优先，移除主网避免错误发送
  connectors: [injected(), binanceConnector()],
  transports: {
    [bsc.id]: http('https://bnb-mainnet.g.alchemy.com/v2/AC0EHKP4Lz9FUL7l8vkHWkipvt4Ww-xK'), // BSC主网RPC
  },
})

// 创建React Query客户端
export const queryClient = new QueryClient()

// 获取币安钱包连接器的辅助函数
export const getBinanceConnector = (connectors: any[]) => {
  return connectors.find((connector) => {
    return connector.id === 'BinanceW3WSDK' || connector.id === 'wallet.binance.com'
  })
}


// 币安钱包专用的网络切换方法
export const switchNetworkInBinance = async (chainId: number) => {
  if (!window.ethereum) {
    throw new Error('以太坊钱包不可用')
  }

  const chainIdHex = `0x${chainId.toString(16)}`
  
  try {
    // 首先尝试直接切换到网络
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: chainIdHex }],
    })
    return true
  } catch (switchError: any) {
    // 如果网络不存在，则添加网络
    if (switchError.code === 4902) {
      try {
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: chainIdHex,
              chainName: 'BNB Smart Chain',
              nativeCurrency: {
                name: 'BNB',
                symbol: 'BNB',
                decimals: 18,
              },
              rpcUrls: ['https://bnb-mainnet.g.alchemy.com/v2/AC0EHKP4Lz9FUL7l8vkHWkipvt4Ww-xK'],
              blockExplorerUrls: ['https://bscscan.com/'],
            },
          ],
        })
        return true
      } catch (addError) {
        console.error('添加BSC网络失败:', addError)
        throw new Error('无法添加BSC网络')
      }
    } else {
      console.error('切换网络失败:', switchError)
      throw switchError
    }
  }
}